import type { PropsWithChildren } from "react";

export const MenuColumn = ({ children }: PropsWithChildren) => {
  return <div className="flex flex-1 flex-col gap-4">{children}</div>;
};
